<nb-layout center class="auth-pages">
	<nb-layout-column>
		<nb-card>
			<nb-card-header>
				<nav class="navigation">
					<a aria-label="Back" class="link" routerLink="/pages">
						<nb-icon icon="arrow-ios-back-outline"></nb-icon>
					</a>
				</nav>
			</nb-card-header>
			<nb-card-body>
				<div class="login-container">
					<h1 id="title" class="title">Forgot Password</h1>
					<p class="sub-title">Enter your email address and we’ll send a security code to reset your password</p>

					<nb-alert *ngIf="!!errorMessage" outline="danger" role="alert">
						<p class="alert-title"><b>{{ 'Errors.RequestPasswordErrorMessage' | translation }}</b></p>
						<p>
							{{errorMessage}}
						</p>
					</nb-alert>

					<form [formGroup]="form" aria-labelledby="title">

						<div class="form-control-group">
							<label class="label" for="input-email">Enter your email address:</label>
							<input nbInput
									fullWidth
									formControlName="email"
									name="email"
									id="input-email"
									pattern=".+@.+\..+"
									placeholder="Email address"
									autofocus
									[status]="form.controls['email'].dirty ? (form.controls['email'].invalid  ? 'danger' : 'success') : ''"
									[required]="true"
									[attr.aria-invalid]="form.controls['email'].invalid && form.controls['email'].touched ? true : null">
							<ng-container *ngIf="form.controls['email'].invalid && form.controls['email'].touched">
								<p class="error-message" *ngIf="form.controls['email'].errors?.required">
									Email is required!
								</p>
								<p class="error-message" *ngIf="form.controls['email'].errors?.pattern">
									Email should be the real one!
								</p>
							</ng-container>
						</div>

						<button nbButton
								fullWidth
								status="success"
								[disabled]="form.invalid"
								[nbSpinner]="loading" nbSpinnerStatus="disabled"
								(click)="onRequest()">
							Request Password
						</button>
					</form>

					<section class="sign-in-or-up" aria-label="Sign in or sign up">
						<p><a class="text-link" routerLink="/login">Back to Log In</a></p>
					</section>

				</div>
			</nb-card-body>
		</nb-card>
	</nb-layout-column>
</nb-layout>
